// import {
//     createApp
// } from 'vue'
// import App from './App.vue'
import * as VueRouter from "vue-router";
import Home from "@/views/pages/Home.vue";
import About from "@/views/pages/About.vue";
import Login from "@/views/pages/Login.vue";
import AdminDashboard from "@/views/pages/AdminDashboard.vue";
import store from "@/store";

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,

    },
    {
      path: "/about",
      name: "About",
      component: About,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/admin",
      name: "AdminDashboard",
      component: AdminDashboard,
      meta: { requiresAdmin: true }
    },
  ],
});

// Guard d'authentification
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/authenticated'];

  // Pages publiques
  if (to.name === 'Login' || to.name === 'About') {
    next();
    return;
  }

  // Page admin nécessite admin + auth
  if (to.meta.requiresAdmin) {
    if (!isAuthenticated) {
      next('/login');
      return;
    }
    const user = store.getters['auth/user'];
    if (!user || (user.is_admin != 1 && user.is_admin !== true)) {
      alert('Accès non autorisé');
      next('/');
      return;
    }
    next();
    return;
  }

  // Page Home nécessite authentification
  if (to.name === 'Home') {
    if (!isAuthenticated) {
      next('/login');
      return;
    }
    next();
    return;
  }

  next();
});
// app.use(router).mount('#app')
// app.mount('app')

export default router;
